import moment from 'moment';
import { buildAxiosClient } from '../../../../common/models/axiosClient';
import type { AxiosPromise } from 'axios';
import type { Customer, Company } from './kycc';
import { Target } from './kycc';

export class KyccClient {
  checkCustomer(target: number, customer: Customer): AxiosPromise<Customer> {
    const data = new FormData();

    customer.conditions.forEach((condition, i) => {
      if (condition.name != null) {
        data.append(
          `company_kycc_customer${
            target === Target.oversea ? '_oversea' : ''
          }[conditions_attributes][${i}][name]`,
          condition.name,
        );
      }

      if (condition.birthday != null && condition.birthday !== '') {
        data.append(
          `company_kycc_customer${
            target === Target.oversea ? '_oversea' : ''
          }[conditions_attributes][${i}][birthday]`,
          moment(condition.birthday).format('YYYY-MM-DD'),
        );
      }
    });

    return buildAxiosClient().post(
      `/api/v1/my/company/kycc/customer${
        target === Target.oversea ? '_oversea' : ''
      }.json`,
      data,
    );
  }

  checkCompany(target: number, company: Company): AxiosPromise<Company> {
    const data = new FormData();
    company.conditions.forEach((condition, i) => {
      if (condition.name != null) {
        data.append(
          `company_kycc_company${
            target === Target.oversea ? '_oversea' : ''
          }[conditions_attributes][${i}][name]`,
          condition.name,
        );
      }
    });

    return buildAxiosClient().post(
      `/api/v1/my/company/kycc/company${
        target === Target.oversea ? '_oversea' : ''
      }.json`,
      data,
    );
  }
}
